import React from 'react';
import { InstagramIcon, MessageCircleIcon, FacebookIcon, PhoneIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
export function Footer() {
  const {
    t,
    lang,
    toggle
  } = useLanguage();
  const links = [{
    href: '#home',
    label: t.nav.home
  }, {
    href: '#services',
    label: t.nav.services
  }, {
    href: '#gallery',
    label: t.nav.gallery
  }, {
    href: '#about',
    label: t.nav.about
  }, {
    href: '#faq',
    label: t.nav.faq
  }, {
    href: '#contact',
    label: t.nav.contact
  }];
  return <footer className="bg-navy text-white" data-id="element-128" data-mp="3lem1g8he2roq">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8" data-id="element-129" data-mp="3ldkdx4j6scq4">
        <div data-id="element-130" data-mp="3qblvtm4vm600">
          <p className="font-display text-xl font-extrabold tracking-tight" data-id="element-131" data-mp="3qfjhofiu9bnl">
            los <span className="text-brand-orange" data-id="element-132" data-mp="29xm24swmjcl7">BROTHERS</span>
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/65" data-id="element-133" data-mp="2ezb9nykn184j">{t.footer.about}</p>
          <div className="mt-5 flex gap-3" data-id="element-134" data-mp="3lalfndz543tf">
            <a href={business.instagramHref} target="_blank" rel="noreferrer" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-135" data-mp="3lbddywk4gfne">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-136" data-mp="81yv6dh5zo1c" />
            </a>
            <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-137" data-mp="34gxjj8lkv8n">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="qtro67w8h992" />
            </a>
            <a href={business.instagramHref} target="_blank" rel="noreferrer" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/20 transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-139" data-mp="mthkx2ztswxw">
              <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="18jr201r1nrv6" />
            </a>
          </div>
        </div>

        <nav aria-label={t.footer.quickLinks} data-id="element-141" data-mp="1cmdw69b6tovj">
          <h2 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-142" data-mp="1clcgtsn52g80">
            {t.footer.quickLinks}
          </h2>
          <ul className="mt-4 space-y-2.5" data-id="element-143" data-mp="1mj8uar3jtn9a">
            {links.map(link => <li key={link.href} data-id="element-144" data-mp="1riv4ssrzspee">
                <a href={link.href} className="text-sm text-white/65 transition-colors duration-150 hover:text-brand-cyan" data-id="element-145" data-mp="1rhtu4pew24x7">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-146" data-mp="2afdjjfzw7eqd">
          <h2 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-147" data-mp="2ag5d6l9xj2e0">
            {t.footer.servicesTitle}
          </h2>
          <ul className="mt-4 space-y-2.5" data-id="element-148" data-mp="25mkess4fc6ea">
            {t.footer.services.map(service => <li key={service} data-id="element-149" data-mp="21kfni01g7lut">
                <a href="#services" className="text-sm text-white/65 transition-colors duration-150 hover:text-brand-cyan" data-id="element-150" data-mp="1wo8oysbdtcmw">
                  {service}
                </a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-151" data-mp="2kd1dw4tl6k80">
          <h2 className="font-display text-sm font-bold uppercase tracking-wide text-white" data-id="element-152" data-mp="2kcrwh5mlxldx">
            {t.footer.contactTitle}
          </h2>
          <ul className="mt-4 space-y-2.5 text-sm text-white/65" data-id="element-153" data-mp="2fdykxiqvs4ge">
            <li data-id="element-154" data-mp="18z5ziyaiafhu">
              <a href={business.phoneHref} className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-brand-cyan" data-id="element-155" data-mp="18zpj0jft1bxz">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-156" data-mp="2ruofp4u56hyd" />
                {business.phoneDisplay}
              </a>
            </li>
            <li data-id="element-157" data-mp="2woalqe5svnl7">
              <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-brand-cyan" data-id="element-158" data-mp="2ivb70edudxep">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-159" data-mp="3bk8cfgwyfzq1" />
                WhatsApp
              </a>
            </li>
            <li data-id="element-160" data-mp="31lj68lef83pm">{t.footer.hours}</li>
            <li className="font-semibold text-brand-orange" data-id="element-161" data-mp="31khh5d0klgow">{t.footer.sameDay}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-162" data-mp="36j2hdcfto0dc">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 text-xs text-white/55 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8" data-id="element-163" data-mp="1q6nepyuoe7rn">
          <p data-id="element-164" data-mp="1v6s0o4ecrup9">
            © {new Date().getFullYear()} los BROTHERS. {t.footer.rights}
          </p>
          <div className="flex flex-wrap items-center gap-5" data-id="element-165" data-mp="1nk4o50pczirp">
            <a href="#faq" className="transition-colors duration-150 hover:text-white" data-id="element-166" data-mp="1iltbyjblcw6b">
              {t.footer.privacy}
            </a>
            <a href="#faq" className="transition-colors duration-150 hover:text-white" data-id="element-167" data-mp="1wlulso9u3dxx">
              {t.footer.terms}
            </a>
            <button type="button" onClick={toggle} aria-label={t.nav.language} className="inline-flex items-center gap-1.5 rounded border border-white/20 px-2 py-1 font-bold uppercase transition-colors duration-150 hover:border-brand-cyan hover:text-brand-cyan" data-id="element-168" data-mp="13xp1u3qltsz5">
              <GlobeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-169" data-mp="18w0a4a193vf9" />
              {lang === 'en' ? 'EN' : 'ES'}
            </button>
          </div>
        </div>
      </div>
    </footer>;
}